/**
 * @generated SignedSource<<f3e9c51b5bcbc9ebb4e003bef22d98a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteExchangeRateInput = {
  id?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteExchangeRateMutation$variables = {
  input: DeleteExchangeRateInput;
};
export type deleteExchangeRateMutation$data = {
  readonly deleteExchangeRate: {
    readonly deletedExchangeRateId: string | null;
  } | null;
};
export type deleteExchangeRateMutation = {
  variables: deleteExchangeRateMutation$variables;
  response: deleteExchangeRateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteExchangeRatePayload",
    "kind": "LinkedField",
    "name": "deleteExchangeRate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedExchangeRateId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteExchangeRateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteExchangeRateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ca7428c710bf26789892b6561c95d1f4",
    "id": null,
    "metadata": {},
    "name": "deleteExchangeRateMutation",
    "operationKind": "mutation",
    "text": "mutation deleteExchangeRateMutation(\n  $input: DeleteExchangeRateInput!\n) {\n  deleteExchangeRate(input: $input) {\n    deletedExchangeRateId\n  }\n}\n"
  }
};
})();

(node as any).hash = "86274c0481673a3b32ea438f2020e826";

export default node;
